import LayoutCode from "!!raw-loader!./formControlLabels/Layout";
import OverflowCode from "!!raw-loader!./formControlLabels/Overflow";
import PlacementCode from "!!raw-loader!./formControlLabels/Placement";
import WrapCode from "!!raw-loader!./formControlLabels/Wrap";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Layout from "./formControlLabels/Layout";
import Overflow from "./formControlLabels/Overflow";
import Placement from "./formControlLabels/Placement";
import Wrap from "./formControlLabels/Wrap";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Label Placement", PlacementCode, Placement),
		paneComponent("Block / Full Width", LayoutCode, Layout),
		paneComponent("Wrap", WrapCode, Wrap),
		paneComponent("Overflow", OverflowCode, Overflow),
	];

	return (
		<Pane
			components={components}
			imports={"import {FormControlLabel} from \"designSystem/index\";"}
			{...props}
		/>
	);
};